<template>
  <div>
    <div class="consumer-ad" v-if="original.ID !== null">
      <div class="header">{{ original.type === '' ? 'NEW' : original.type.toUpperCase() }} AD {{ adId !== 'new' ? adId : '' }}</div>
      <div class="row field-container">
        <div class="small-6 columns padding-R">
          <div class="card">
            <div class="card-title">AD SETTINGS</div>
            <div class="row">
              <div class="small-6 columns padding-R">
                <div class="label-value">
                  <label>Start Date</label>
                  <datepicker class="datepicker" format="MM/dd/yyyy" v-model="startDate"></datepicker>
                </div>
              </div>
              <div class="small-6 columns padding-L">
                <div class="label-value">
                  <label>End Date</label>
                  <datepicker class="datepicker" format="MM/dd/yyyy" v-model="endDate"></datepicker>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="small-6 columns padding-R">
                <div class="label-value">
                  <label>Ad Type</label>
                  <div class="select-input">
                    <select v-model="adType">
                      <option value="web">Web</option>
                      <option value="consumer">Consumer</option>
                      <option value="provider">Provider</option>
                    </select>
                    <i class="fa fa-angle-down"></i>
                  </div>
                </div>
              </div>
              <div class="small-6 columns padding-L">
                <div class="label-value">
                  <label>Brand</label>
                  <div class="select-input">
                    <select v-model.number="brandId">
                      <option v-for="brand in brands" :value="brand.id" :selected="brand.id === original.brandId">{{ brand.name }}</option>
                    </select>
                    <i class="fa fa-angle-down"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card excerpt-fields">
            <div class="card-title">AD EXCERPT</div>
            <div class="image-input">
              <div class="uploading" v-show="uploading.excerpt"><i class="fa fa-spinner fa-spin fa-2x"></i></div>
              <input type="file" accept="image/*" @change="uploadImage($event, true)" />
              <img :src="tooltipImage" />
              <div class="guideline">300 x 300</div>
            </div>
            <div class="label-value margin-T-z">
              <label>Title</label>
              <input type="text" v-model="tooltipTitle" />
            </div>
            <div class="label-value">
              <label>Message</label>
              <input type="text" v-model="tooltipDescription" />
            </div>
          </div>
          <div class="card content-fields">
            <div class="card-title">AD CONTENT</div>

            <div class="image-input">
              <div class="uploading" v-show="uploading.main"><i class="fa fa-spinner fa-spin fa-2x"></i></div>
              <input type="file" accept="image/*" @change="uploadImage($event, false)" />
              <img :src="mainImage" />
              <div class="guideline">700 x 700</div>
            </div>
            <div class="label-value margin-T-z margin-image">
              <label>Page Title</label>
              <input type="text" v-model="mainHeader" />
            </div>
            <div class="label-value margin-image">
              <label>Content Title</label>
              <input type="text" v-model="mainTitle" />
            </div>
            <div class="label-value">
              <label>Content Body</label>
              <textarea v-model="mainBody"></textarea>
            </div>
            <div class="row">
              <div class="small-6 columns padding-R">
                <div class="label-value">
                  <label>CTA Label</label>
                  <input type="text" v-model="ctaText" />
                </div>
              </div>
              <div class="small-6 columns padding-L">
                <div class="label-value">
                  <label>CTA Link (Optional)</label>
                  <input type="text" v-model="ctaLink" />
                </div>
              </div>
            </div>
          </div>

          <div class="card action-div">
            <div class="row">
              <div class="small-12 columns">
                <div class="error-message" v-show="error.show">{{ error.message }}</div>
              </div>
            </div>
            <div class="row action-btns">
              <div class="small-6 columns padding-R">
                <a class="button cta small block secondary" href="javascript:;" @click="$router.go(-1)">CANCEL</a>
              </div>
              <div class="small-6 columns padding-L">
                <a v-bind:class="{'button cta small block success': true, disabled: saving}" href="javascript:;" @click="save">
                  <i class="fa fa-spin fa-spinner" v-show="saving"></i>
                  <span v-show="!saving">SAVE</span>
                </a>
              </div>
              <!--div class="small-4 columns padding-L">
                <a class="button cta small block warning" href="javascript:;" v-if="original.published">UNPUBLISH</a>
                <a class="button cta small block" href="javascript:;" v-else>PUBLISH</a>
              </div-->
            </div>
          </div>
        </div>
        <div class="small-6 columns padding-L">
          <consumer-ad-preview v-if="adType === 'consumer'"></consumer-ad-preview>
          <web-ad-preview v-if="adType === 'web'"></web-ad-preview>
        </div>
      </div>
    </div>
    <div class="loader" v-show="loading">
      <div class="loader-content">
        <div class="loading" v-show="!done">
          <i class="fa fa-spinner fa-spin fa-2x"></i>
          <div class="message">Saving Ad...</div>
        </div>
        <div class="loading" v-show="done && success">
          <i class="fas fa-check-circle fa-2x"></i>
          <div class="message">Ad successfully saved.</div>
        </div>
        <div class="loading" v-show="done && !success">
          <i class="fas fa-times-circle fa-2x"></i>
          <div class="message">Oops something went wrong.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import datepicker from 'vuejs-datepicker'
import ConsumerAdPreview from './ConsumerAdPreview'
import WebAdPreview from './WebAdPreview'

export default {
  name: 'consumer-ad-details',
  components: { datepicker, ConsumerAdPreview, WebAdPreview },
  data () {
    return {
      uploading: {
        excerpt: false,
        main: false
      },
      error: {
        show: false,
        message: ''
      },
      saving: false,
      loading: false,
      done: false,
      success: false
    }
  },
  computed: {
    adId () { return this.$route.params.id },
    original () { return this.$store.state.ads.adItem.original },
    brands () { return this.$store.state.brands.list },
    tooltipImage: {
      get () { return this.$store.state.ads.adItem.edited.tooltipImage },
      set (value) { this.$store.commit('ads/setEditedTooltipImage', value) }
    },
    tooltipTitle: {
      get () { return this.$store.state.ads.adItem.edited.tooltipTitle },
      set (value) { this.$store.commit('ads/setEditedTooltipTitle', value) }
    },
    tooltipDescription: {
      get () { return this.$store.state.ads.adItem.edited.tooltipDescription },
      set (value) { this.$store.commit('ads/setEditedTooltipDescription', value) }
    },
    mainImage: {
      get () { return this.$store.state.ads.adItem.edited.mainImage },
      set (value) { this.$store.commit('ads/setEditedMainImage', value) }
    },
    mainHeader: {
      get () { return this.$store.state.ads.adItem.edited.mainHeader },
      set (value) { this.$store.commit('ads/setEditedMainHeader', value) }
    },
    mainTitle: {
      get () { return this.$store.state.ads.adItem.edited.mainTitle },
      set (value) { this.$store.commit('ads/setEditedMainTitle', value) }
    },
    mainBody: {
      get () { return this.$store.state.ads.adItem.edited.mainBody },
      set (value) { this.$store.commit('ads/setEditedMainBody', value) }
    },
    ctaText: {
      get () { return this.$store.state.ads.adItem.edited.ctaText },
      set (value) { this.$store.commit('ads/setEditedCtaText', value) }
    },
    ctaLink: {
      get () { return this.$store.state.ads.adItem.edited.ctaLink },
      set (value) { this.$store.commit('ads/setEditedCtaLink', value) }
    },
    brandId: {
      get () { return this.$store.state.ads.adItem.edited.brandId },
      set (value) { this.$store.commit('ads/setEditedBrandId', value) }
    },
    startDate: {
      get () { return this.$store.state.ads.adItem.edited.startDate.toDate() },
      set (value) { this.$store.commit('ads/setEditedStartDate', moment(value)) }
    },
    endDate: {
      get () { return this.$store.state.ads.adItem.edited.endDate.toDate() },
      set (value) { this.$store.commit('ads/setEditedEndDate', moment(value)) }
    },
    adType: {
      get () { return this.$store.state.ads.adItem.edited.type },
      set (value) { this.$store.commit('ads/setEditedType', value) }
    }
  },
  methods: {
    getAd () {
      let self = this
      self.$sdk.get('/brand', {}, res => {
        self.$store.commit('brands/setLoading', false)
        // self.$store.commit('rsvpDetails/setBrandsLoading', false)
        let brands = []
        res.forEach(function (data) {
          brands.push({
            id: data.id,
            name: data.name
          })
        })
        self.$store.commit('brands/setList', brands)
        if (self.adId === 'new') {
          console.log('new ad')
          let newAd = {
            ID: -1,
            brandId: -1,
            ctaLink: '',
            ctaText: '',
            mainBody: '',
            mainHeader: '',
            mainTitle: '',
            mainImage: '/assets/img/empty.png',
            tooltipTitle: '',
            tooltipDescription: '',
            tooltipImage: '/assets/img/empty.png',
            startDate: moment(),
            endDate: moment(),
            published: 0,
            type: ''
          }
          self.$store.commit('ads/setOriginalAdItem', newAd)
          self.$store.commit('ads/setEditedAdItem', newAd)
          return
        }
        self.$sdk.get('/ads/' + self.adId, {
          token: self.$store.state.session.sessionToken
        }, r => {
          if (r.error) {
            // show error
            return
          }
          let startDateStr = r.startDate.substr(0, 10) + ' 00:01'
          let endDateStr = r.endDate.substr(0, 10) + ' 23:59'
          r.startDate = moment(startDateStr, 'YYYY-MM-DD HH:mm')
          r.endDate = moment(endDateStr, 'YYYY-MM-DD HH:mm')
          self.$store.commit('ads/setOriginalAdItem', r)
          self.$store.commit('ads/setEditedAdItem', r)
        })
      })
    },
    uploadImage (e, isExcerpt) {
      let self = this

      let file = e.target.files[0];
      let fd = new FormData()
      fd.append('pic', file)

      if (isExcerpt) {
        self.uploading.excerpt = true
      } else {
        self.uploading.main = true
      }
      self.$http.post(CONFIG.mediaHost + '/api/upload', fd, {
        header: { 'Content-Type': 'multipart/form-data'}
      }).then(function (res) {
        let imageUrl = res.body.data.url
        if (isExcerpt) {
          self.$store.commit('ads/setEditedTooltipImage', imageUrl)
        } else {
          self.$store.commit('ads/setEditedMainImage', imageUrl)
        }
        self.uploading.excerpt = false
        self.uploading.main = false
      }, function (res) {
        console.log('error ad image upload', res)
        self.uploading.excerpt = false
        self.uploading.main = false
      });
    },
    isValid () {
      let self = this
      if (self.tooltipImage === '' || self.tooltipImage === '/assets/img/empty.png') {
        self.error.show = true
        self.error.message = 'Excerpt Image is required.'
        return false
      }
      if (self.mainImage === '' || self.mainImage === '/assets/img/empty.png') {
        self.error.show = true
        self.error.message = 'Content Image is required.'
        return false
      }
      if (self.tooltipTitle === '') {
        self.error.show = true
        self.error.message = 'Excerpt Title is required.'
        return false
      }
      if (self.tooltipDescription === '') {
        self.error.show = true
        self.error.message = 'Excerpt Message is required.'
        return false
      }
      if (self.mainHeader === '') {
        self.error.show = true
        self.error.message = 'Page Title is required.'
        return false
      }
      if (self.mainTitle === '') {
        self.error.show = true
        self.error.message = 'Content Title is required.'
        return false
      }
      if (self.mainBody === '') {
        self.error.show = true
        self.error.message = 'Content Body is required.'
        return false
      }
      if (self.ctaText === '') {
        self.error.show = true
        self.error.message = 'CTA Text is required.'
        return false
      }
      if (self.adType === '') {
        self.error.show = true
        self.error.message = 'Ad Type is required.'
        return false
      }
      if (self.brandId === -1) {
        self.error.show = true
        self.error.message = 'Brand is required.'
        return false
      }
      let startDate = self.$store.state.ads.adItem.edited.startDate
      let endDate = self.$store.state.ads.adItem.edited.endDate
      if (endDate.isBefore(startDate)) {
        self.error.show = true
        self.error.message = 'End Date must be after Start Date.'
        return false
      }
      self.error.show = false
      self.error.message = ''
      return true
    },
    save () {
      let self = this
      if (!self.isValid()) {
        return
      }
      // 2018-08-08 00:01:00
      let startDate = self.$store.state.ads.adItem.edited.startDate.format('YYYY-MM-DD') + ' 00:01:00'
      let endDate = self.$store.state.ads.adItem.edited.endDate.format('YYYY-MM-DD') + ' 23:59:00'

      let request = {
        token: self.$store.state.session.sessionToken,
        type: self.adType,
        brandId: self.brandId,
        tooltipImage: self.tooltipImage,
        tooltipTitle: self.tooltipTitle,
        tooltipDescription: self.tooltipDescription,
        mainHeader: self.mainHeader,
        mainImage: self.mainImage,
        mainTitle: self.mainTitle,
        mainBody: self.mainBody,
        ctaText: self.ctaText,
        ctaLink: self.ctaLink,
        published: 0,
        startDate: startDate,
        endDate: endDate
      }
      let url = '/ads'
      if (self.adId !== 'new') {
        url = '/ads/' + self.adId
      }
      self.loading = true
      self.done = false
      self.success = false
      self.$sdk.post(url, request, r => {
        self.done = true
        if (r.error) {
          self.success = false
          setTimeout(() => {
            self.loading = false
          }, 1500)
          return
        }
        self.success = true
        setTimeout(() => {
          self.$router.push('/ads')
        }, 1500)
      })
    }
  },
  watch: {
    adId (value) { this.getAd() }
  },
  mounted () {
    this.getAd()
  }
}
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 51px;
  font-weight: 700;
  font-size: 22px;
  color: #3F2975;
  background-color: #fff;
  display: block;
  line-height: 22px;
  padding: 14px 0 14px 64px;
  border-bottom: 1px solid rgba(0,0,0,0.15);
  z-index: 10;
}

.field-container {
  margin: 51px 0 30px;
}
.card{
  padding: 15px;
  margin-top: 15px;
}

.card-title{
  font-weight: 700;
  font-size: 12px;
  color: #0D79F2
}

.image-input {
  width: 140px;
  height: 140px;
  position: relative;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);
  cursor: pointer;
  & img { width: 160px; }

  & .guideline {
    font-size: 12px;
    color: #fff;
    background-color: rgba(0,0,0,0.4);
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 5px;
    text-align: center;
    font-weight: 700;
  }

  & input[type="file"] {
    position: absolute;
    top: 0;
    left: 0;
    width: 140px;
    height: 140px;
    cursor: pointer;
    opacity: 0;
    z-index: 8;
  }
  & .uploading {
    position: absolute;
    top: 0;
    left: 0;
    width: 140px;
    height: 140px;
    background-color: rgba(0,0,0,0.5);
    z-index: 9;

    & i{
      display: block;
      text-align: center;
      line-height: 140px;
      color: #fff;
    }
  }
}


.label-value{
  margin-top: 10px;
  & label {
    font-size: 12px;
    font-weight: 700;
    color: #555;
  }
  & input, textarea, select {
    margin-top: 0;
  }

  & textarea{
    resize: none;
    height: 300px;
  }

  & .select-input {
    position: relative;

    & i {
      position: absolute;
      color: #777;
      top: 12px;
      right: 10px;
    }
  }
  & select {
    outline: 0;
    padding: 10px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -webkit-appearance:none;
    -moz-appearance: none;
    border: 1px solid rgba(0,0,0,0.15);
    background-color: #fff;
  }
}

.excerpt-fields{
  position: relative;

  & .image-input{
    position: absolute;
    bottom: 15px;
    left: 15px;
  }

  & .label-value {
    margin-left: 155px;
  }
}

.content-fields{
  position: relative;

  & .image-input{
    position: absolute;
    top: 42px;
    left: 15px;
  }

  & .label-value.margin-image{
    margin-left: 155px;
  }
}

.error-message {
  color: #F20D0D;
  border: 3px solid #F20D0D;
  text-align: center;
  padding: 5px;
  font-weight: 700;
  border-radius: 3px;
  margin-bottom: 10px;
}

.loader {
  position: fixed;
  z-index: 12;
  background-color: rgba(0,0,0,0.75);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: table;
}

.loader-content {
  display: table-cell;
  vertical-align: middle;
}

.loading {
  max-width: 300px;
  margin: 0 auto;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  border-radius: 3px;
  text-align: center;
  padding: 20px;

  & .message {
    margin-top: 5px;
  }

  & i.fa-check-circle{ color: #26D97A; }
  & i.fa-times-circle{ color: #F20D0D; }
}
.margin-T-z{ margin-top: 0; }
.padding-L{ padding-left: 7px; }
.padding-R{ padding-right: 7px; }

@media only screen and (max-width: 430px) {
  .field-container {
    margin-top: 35px;
  }

  .card {
    margin: 30px;

    &.action-div {
      margin: 0;
    }
  }
  .small-6 {
    width: 100%;
  }

  .padding-L, .padding-R {
    padding: 0;
  }

  .content-fields {
    margin-bottom: 80px;
    .image-input {
      position: relative;
      margin: 0 auto;
      top: 0;
      left: 0;
    }
    .label-value.margin-image {
      margin-left: 0;
    }
  }

  .excerpt-fields {
    .image-input {
      position: relative;
      margin: 0 auto;
      top: 0;
      left: 0;
    }
    .label-value {
      margin-left: 0;
    }
  }

  .action-div {
    position: fixed;
    bottom: 0;
    z-index: 1;
    width: 100%;
  }

  .action-btns {
    .small-6 {
      width: 50%;
      padding: 0 3px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MarketingAds/AdDetails.vue